<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>Certificate Report</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col cols="12" sm="12" md="3"></v-col>
                <v-col cols="12" sm="12" md="3">
                    <b>Standard</b>
                    <v-autocomplete v-model="editedItem.standard" :items="standard_list" item-text="standard"
                        item-value="id" label="Standard" single-line rounded outlined dense multiple></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="3">
                    <b>Certificate Type</b>
                    <v-autocomplete v-model="editedItem.certificate_type" :items="certificatestype_list"
                        label="Certificate Type" item-text="name" item-value="id" single-line rounded outlined
                        dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3"></v-col>
            </v-row>
            <v-row justify="center" dense>
                <v-col cols="12" sm="12" md="2">
                    <v-btn class="button" @click="fetchCertificateReport()">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>

        <div>
            <v-col cols="12" sm="3" md="3" v-if="certificates_list != ''">
                <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'CertificateReport')"
                    :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>
            <div id="my-table-id">
                <v-card>
                    <v-card-title v-if="certificates_list != ''">
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" background-color="white" append-icon="mdi-magnify" label="Search"
                            single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-simple-table class="elevation-1 mytable" v-if="certificates_list != ''" fixed-header
                        height="500px">
                        <template>
                            <thead>
                                <tr>
                                    <th>Certificate No</th>
                                    <th>GR Number</th>
                                    <th>Registration Number</th>

                                    <th>Standard</th>
                                    <th>Division</th>
                                    <th>Full Name</th>
                                    <th>Section</th>
                                    <th>Date Of Application</th>
                                    <th>Date Of Issue</th>
                                    <th>Generation Date</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr v-for="(item, index) in filteredItems" :key="index">
                                    <td>
                                        <v-tooltip top color="warning"
                                            v-if="item.certificate_type == 'Leaving Certificate'">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn class="mt-1 mb-1" outlined rounded small color="warning"
                                                    v-bind="attrs" v-on="on" @click="
                                                        fetchLC(
                                                            item.lid,
                                                            item.registration_number,
                                                            item.fullname,
                                                        )
                                                        ">
                                                    <v-icon color="warning">mdi-printer</v-icon>
                                                    {{ item.certificate_no }}
                                                </v-btn>
                                            </template>
                                            <span> Print Leaving Certificate !!! </span>
                                        </v-tooltip>
                                        <v-tooltip top color="warning" v-if="item.certificate_type == 'Bonafide'">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn class="mt-1 mb-1" outlined rounded small color="warning"
                                                    v-bind="attrs" v-on="on" @click="showCert1(item)">
                                                    <v-icon color="warning">mdi-printer</v-icon>
                                                    {{ item.certificate_no }}
                                                </v-btn>
                                            </template>
                                            <span> Print Bonafide !!! </span>
                                        </v-tooltip>
                                    </td>
                                    <td>{{ item.gr_number }}</td>
                                    <td>{{ item.registration_number }}</td>
                                    <td>{{ item.standard }}</td>
                                    <td>{{ item.division }}</td>
                                    <td>{{ item.fullname }}</td>
                                    <td>{{ item.section }}</td>
                                    <td>{{ item.date_of_application }}</td>
                                    <td>{{ item.date_of_issue }}</td>
                                    <td>{{ item.gen_date }}</td>

                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
            </div>
            <!-- <div id="my-table-id">
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" background-color="white" append-icon="mdi-magnify" label="Search" single-line
                            hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="certificates_list" class="elevation-1 box mytable"
                        :search="search">

                    </v-data-table>
                </v-card>
            </div> -->
        </div>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        valid: false,
        overlay: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        org_basic_data: null,
        lc_data: null,
        extra_curricular_activities: [],
        extra_curricular_activity: "",
        gen_date: new Date().toISOString().substr(0, 10),
        date_of_application: new Date().toISOString().substr(0, 10),
        date_of_issue: new Date().toISOString().substr(0, 10),
        table_fields: {
            "Certificate No": "certificate_no",
            "GR Number": "gr_number",
            "Registration Number": "registration_number",
            "Full Name ": "fullname",
            "Date Of Application": "date_of_application",
            "Date Of Issue": "date_of_issue",
            "Generation Date": "gen_date",
        },
        headers: [
            {
                text: "Certificate No",
                align: "left",
                sortable: false,
                value: "certificate_no",
            },
            {
                text: "GR Number",
                align: "left",
                sortable: false,
                value: "gr_number",
            },
            {
                text: "Registration Number",
                align: "left",
                sortable: false,
                value: "registration_number",
            },
            {
                text: "Standard",
                align: "left",
                sortable: false,
                value: "standard",
            },
            {
                text: "Division",
                align: "left",
                sortable: false,
                value: "division",
            },
            {
                text: "Full Name",
                align: "left",
                sortable: false,
                value: "fullname",
            },
            {
                text: "Section",
                align: "left",
                sortable: false,
                value: "section",
            },
            {
                text: "Date Of Application",
                align: "left",
                sortable: false,
                value: "date_of_application",
            },
            {
                text: "Date Of Issue",
                align: "left",
                sortable: false,
                value: "date_of_issue",
            },
            {
                text: "Generation Date",
                align: "left",
                sortable: false,
                value: "gen_date",
            },
        ],
        emp_approval_details: [],
        standard_list: [],
        certificatestype_list: [],
        leave_approval_status_list: [],

        certificates_list: [],
        editedItem: {
            standard: "",
            certificate_type: null,

        },
    }),

    mounted() {
        this.tenant = localStorage.getItem("EPS-tenant");
        this.org_id = localStorage.getItem("EPS-org-id")
        this.onLoad();
    },
    computed: {
        filteredItems() {
            return this.certificates_list.filter((item) => {
                return (
                    (item.certificate_no ? item.certificate_no.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1 ||
                    (item.registration_number ? item.registration_number.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1 ||
                    (item.gr_number ? item.gr_number.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1 ||
                    (item.standard ? item.standard.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1 ||
                    (item.division ? item.division.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1 ||
                    (item.section ? item.section.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1 ||
                    (item.date_of_application ? item.date_of_application.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1 ||
                    (item.date_of_issue ? item.date_of_issue.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1 ||
                    (item.gen_date ? item.gen_date.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1 ||
                    (item.fullname ? item.fullname.toLowerCase() : '').indexOf(this.search.toLowerCase()) > -1
                );
            });
        }



    },
    methods: {
        showCert1(item) {
            if (this.tenant === 'sanjivani') {
                if (this.org_id == '5' || this.org_id == '6') {
                    localStorage.setItem("cert_data", JSON.stringify(item.cert_data));
                    localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                    localStorage.setItem("rollno", JSON.stringify(item.rollno));
                    let routeData = this.$router.resolve({ name: "get-bonafied-certificate-report-print-SJCV" });
                    window.open(routeData.href, "_blank");

                } else if (this.org_id == '4') {
                    localStorage.setItem("cert_data", JSON.stringify(item.cert_data));
                    localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                    let routeData = this.$router.resolve({ name: "get-bonafied-certificate-report-print-ssjc" });
                    window.open(routeData.href, "_blank");
                }
                else {
                    localStorage.setItem("cert_data", JSON.stringify(item.cert_data));
                    localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                    localStorage.setItem("prno",item.prno);
                    let routeData = this.$router.resolve({ name: "get-bonafied-certificate-report-print-sanjivani" });
                    window.open(routeData.href, "_blank");

                }

            }
            else if (this.tenant === 'vvp') {
                localStorage.setItem("cert_data", JSON.stringify(item.cert_data));
                localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                let routeData = this.$router.resolve({ name: "get-bonafied-certificate-report-print-vvp" });
                window.open(routeData.href, "_blank");

            }
            else if (this.tenant === 'wws') {
                localStorage.setItem("cert_data", JSON.stringify(item.cert_data));
                localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                localStorage.setItem("prno", JSON.stringify(item.prno));
                localStorage.setItem("reason", JSON.stringify(item.reason));
                let routeData = this.$router.resolve({ name: "get-bonafied-certificate-report-print-wws" });
                window.open(routeData.href, "_blank");

            } else if (this.tenant === 'zeal') {
                localStorage.setItem("cert_data", JSON.stringify(item.cert_data));
                localStorage.setItem(
                    "org_basic_data",
                    JSON.stringify(this.org_basic_data)
                );

                let routeData = this.$router.resolve({ name: "get-bonafied-certificate-report-print-zeal" });
                window.open(routeData.href, "_blank");
            }
            else {
                localStorage.setItem("cert_data", JSON.stringify(item.cert_data));
                localStorage.setItem(
                    "org_basic_data",
                    JSON.stringify(this.org_basic_data)
                );

                let routeData = this.$router.resolve({ name: "get-certificate-for-report-print" });
                window.open(routeData.href, "_blank");

            }



        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        fetchLC(lid,
            registration_number,
            name,) {
            this.overlay = true;
            const data = {
                lid: lid,
                registration_number: registration_number,
                name: name,

            };
            axios
                .post("/certificate/fetchLC", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.org_basic_data = res.data.org_basic_data;
                        this.lc_data = res.data.lc_data;
                        if (this.lc_data.extra_curricular_activities) {
                            this.extra_curricular_activity = this.lc_data.extra_curricular_activities
                        }
                        // this.lc_data.last_school = this.org_basic_data.school_name;
                        this.date_of_application = this.formatDate(
                            this.lc_data.date_of_application
                        );
                        this.date_of_issue = this.formatDate(this.lc_data.date_of_issue);
                        this.gen_date = this.formatDate(this.lc_data.cert_date);
                        // this.showSnackbar("green", "User data fetched!!!");
                        this.overlay = false;
                        this.proceed();
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })

        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year}`;
        },
        proceed() {
            // console.log("is", this.is_promoted_to_next_standard.name);
            if (this.tenant == 'zeal') {
                localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                let routeData = this.$router.resolve({ name: "zeal-lc-print" });
                window.open(routeData.href, "_blank");
            } else if (this.tenant == 'wws') {
                localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                let routeData = this.$router.resolve({ name: "wws-lc-print" });
                window.open(routeData.href, "_blank");
            } else if (this.tenant == 'vvp') {
                localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                // console.log(this.lc_data)
                localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                let routeData = this.$router.resolve({ name: "vvp-lc-print" });
                window.open(routeData.href, "_blank");
            } else if (this.tenant == 'sanjivani') {
                if (this.org_id == '1') {
                    localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                    localStorage.setItem(
                        "org_basic_data",
                        JSON.stringify(this.org_basic_data)
                    );
                    let routeData = this.$router.resolve({ name: "sak-lc-print" });
                    window.open(routeData.href, "_blank");
                }
                if (this.org_id == '2') {
                    localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                    localStorage.setItem(
                        "org_basic_data",
                        JSON.stringify(this.org_basic_data)
                    );
                    localStorage.setItem(
                        "is_promoted_to_next_standard",
                        JSON.stringify(this.is_promoted_to_next_standard)
                    );
                    localStorage.setItem(
                        "Whether_failed_in_same_class",
                        JSON.stringify(this.Whether_failed_in_same_class)
                    );
                    localStorage.setItem(
                        "whether_ncc_cadet",
                        JSON.stringify(this.whether_ncc_cadet)
                    );
                    let routeData = this.$router.resolve({ name: "sis-lc-print" });
                    window.open(routeData.href, "_blank");
                } if (this.org_id == '3') {
                    localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                    localStorage.setItem(
                        "org_basic_data",
                        JSON.stringify(this.org_basic_data)
                    );
                    localStorage.setItem(
                        "is_promoted_to_next_standard",
                        JSON.stringify(this.is_promoted_to_next_standard)
                    );
                    localStorage.setItem(
                        "Whether_failed_in_same_class",
                        JSON.stringify(this.Whether_failed_in_same_class)
                    );
                    localStorage.setItem(
                        "whether_ncc_cadet",
                        JSON.stringify(this.whether_ncc_cadet)
                    );
                    let routeData = this.$router.resolve({ name: "sav-lc-print" });
                    window.open(routeData.href, "_blank");
                }
                if (this.org_id == '4') {
                    localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                    localStorage.setItem(
                        "org_basic_data",
                        JSON.stringify(this.org_basic_data)
                    );
                    let routeData = this.$router.resolve({ name: "ssjc-lc-print" });
                    window.open(routeData.href, "_blank");
                } if (this.org_id == '5') {
                    localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                    localStorage.setItem(
                        "org_basic_data",
                        JSON.stringify(this.org_basic_data)
                    );
                    let routeData = this.$router.resolve({ name: "sjcv-lc-print" });
                    window.open(routeData.href, "_blank");
                }
                if (this.org_id == '6') {
                    localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                    localStorage.setItem(
                        "org_basic_data",
                        JSON.stringify(this.org_basic_data)
                    );
                    let routeData = this.$router.resolve({ name: "sjck-lc-print" });
                    window.open(routeData.href, "_blank");
                }

            } else {
                localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                localStorage.setItem(
                    "org_basic_data",
                    JSON.stringify(this.org_basic_data)
                );
                localStorage.setItem(
                    "is_promoted_to_next_standard",
                    JSON.stringify(this.is_promoted_to_next_standard)
                );
                localStorage.setItem(
                    "Whether_failed_in_same_class",
                    JSON.stringify(this.Whether_failed_in_same_class)
                );
                // is_promoted_to_next_standard
                let routeData = this.$router.resolve({ name: "sbpps-lc-print" });
                window.open(routeData.href, "_blank");
            }

        },
        fetchCertificateReport() {
            this.overlay = true;
            this.certificates_list = []
            // if (
            //     this.editedItem.standard == "" ||
            //     this.editedItem.certificate_type == null
            // ) {
            //     this.showSnackbar("#b71c1c", "Please Fill All The Fields");
            //     this.overlay = false;
            // } else {
            axios
                .post(
                    "/certificate/getCertificateReport",
                    this.editedItem
                )
                .then((res) => {
                    if (res.data.flag == "YES") {
                        if ((this.load = true)) {
                            this.overlay = false;
                            this.certificates_list =
                                res.data.certificates_list;
                            this.org_basic_data = res.data.org_basic_data;

                        }
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", "No Certificates Found...");
                        this.onLoad();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");

                })
                .finally(() => {
                    var overlay = false;
                });

        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/certificate/getCertificateReportHome")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        if ((this.load = true)) {
                            this.overlay = false;
                            this.standard_list = res.data.standard_list_All;
                            this.certificatestype_list = res.data.certificatestype_list;
                            // this.editedItem.ay = res.data.current_ay;

                            if(this.standard_list.length > 0){
                               this.standard_list = [{ id: null, standard: "All" }, ...(res.data.standard_list_All || [])];
                            }
                        }
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");

                })
                .finally(() => {
                    var overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>
<style scoped>
input[type="date"] {
    width: 100%;
    display: inline-block;
    padding: 0.3rem;
    border: 1px solid gray;
    border-radius: 30px;
    box-sizing: border-box;
    padding-top: none !important;
    margin-top: none !important;
}

.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.tc-title {
    background-image: linear-gradient(-90deg, #fff, blue);
    color: #fff;
    border-radius: 3px;
}

.table-head {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    color: white !important;
}

.textcolor {
    color: darkblue;
    font-weight: bold;
}

td,
th {
    border: 1px solid #ccc;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
}

td {
    font-weight: bold;
}

td {
    margin: 1rem !important;
    padding: 1rem !important;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
    }

    td+td,
    th+th {
        width: auto;
    }
}

sub-row {
    border: 2px solid #424093;
    margin: 1rem;
    border-radius: 5px;
}

i {
    font-size: 20px !important;
}

.v-card__title {
    border: 1px solid #80808040;
    font-weight: bold;
    background-color: #424093;
    color: white;
    text-align: center;
    /* margin-top: 1.5rem; */
}

.card-border {
    border: 2px solid darkblue;
    border-radius: 10px;
    /* padding: 5px; */
    /* margin: 1rem !important; */
    width: auto;
}

.tx-bold {
    font-weight: bold;
    font-size: 14px;
    color: black;
}

i {
    font-size: 26px;
    cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #424093 !important;
    color: white !important;
    margin-top: 2.35rem;
    border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {}

.imgs {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px;
    cursor: zoom-in;
}

.imgs-preview {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: auto;
}

v-simple-table {
    border-collapse: collapse;
    border-spacing: 0;
    width: auto;
    border: 1px solid #ddd;
}

th {
    color: white;
    font-weight: bold;
    text-align: center !important;
}

td,
th {
    padding: 6px;
    border: 1px solid #ccc;
    text-align: center;
}

@media all and (max-width: 900px) {
    .padding-bot {
        padding: 8px;
    }
}

@media all and (min-width: 1000px) {
    .padding-metting {
        padding-right: 22px;
    }
}

@media (min-width: 320px) and (max-width: 350px) {
    .padding-bot {
        font-size: 11.6px;
    }
}

@media (min-width: 1000px) and (max-width: 1050px) {
    .padding-bot {
        font-size: 9.6px;
    }
}

.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}
</style>
